import { render, staticRenderFns } from "./PuzzleHints.vue?vue&type=template&id=2f35d397&"
import script from "./PuzzleHints.vue?vue&type=script&lang=js&"
export * from "./PuzzleHints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports